import { defineMessage } from 'services/localization';

export const messages = {
    connecting: defineMessage('connecting'),
    connected: defineMessage('you_are_connected_to_company'),
    disconnecting: defineMessage('disconnecting_from_company'),
    disconnected: defineMessage('disconnected_from_company'),
    disconnectButton: defineMessage('disconnect'),
    reconnectButton: defineMessage('reconnect'),
    error: defineMessage('disconnected_from_companybrreason'),
    learnMore: defineMessage('learn_more'),
};

export const messagesXero = {
    title: defineMessage('xeroconnected_approval_workflows'),
    descriptionConnecting: defineMessage('please_wait_approvalmax__your_xero_organisation'),
};

export const messagesQBO = {
    title: defineMessage('quickbooks_online_approval_workflows'),
    descriptionConnecting: defineMessage('please_wait_approvalmax_oks_online_organisation'),
};

export const messagesNetSuite = {
    title: defineMessage('oracle_netsuite_approval_workflows'),
    descriptionConnecting: defineMessage('please_wait_approvalmax_oracle_netsuite_company'),
};

export const messagesCin7 = {
    title: defineMessage('cin_core_approval_workflows'),
    descriptionConnecting: defineMessage('please_wait_approvalmax_o_your_cin_core_company'),
};
